module.exports = __webpack_public_path__ + "static/img/img_p3_1_pic.b4d60e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p3_1_pic.png
// module id = W/f1
// module chunks = 1